﻿import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import { VeilederUtstyrsstipendAppState } from '../Store/index';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';
import { connect } from 'react-redux';

import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';

import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';

type UtbetalingProps = MapStateToProps;

class UtbetalingComponent extends React.PureComponent<UtbetalingProps> {
    utbetalingRef = React.createRef<HTMLDivElement>();

    constructor(props: UtbetalingProps) {
        super(props);
    }

    render(): JSX.Element {
        const { epiContext } = this.props;
        // const { locale } = this.props.epiContext;

        return (
            <div className="c-veileder__panel c-veileder__panel--info c-veileder__panel--white-aubergine">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'overskriftUtbetaling')}
                        </h3>
                        <p>{contentResolver(epiContext, 'infoUtbetaling')}</p>
                    </div>
                    <div className="c-veileder__content">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'overskriftSignering')}
                        </h3>
                        <p>{contentResolver(epiContext, 'infoSignering')}</p>
                        <p>{contentResolver(epiContext, 'infoHuskAsoke')}</p>
                    </div>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederUtstyrsstipendDto>;
}

export default connect(
    (state: VeilederUtstyrsstipendAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
    { updateZIndex },
)(UtbetalingComponent);
